/**
 * components/team/StatusPill.js
 * ACTIVE / SUSPENDED / REMOVED as a pill.
 */
import React from "react";
import { S } from "./teamStyles.js";

const StatusPill = ({ status }) => {
  const map = {
    ACTIVE: ["#047857", "#dcfce7"],
    SUSPENDED: ["#b45309", "#fef3c7"],
    REMOVED: ["#dc2626", "#fee2e2"],
  };
  const [color, bg] = map[status] || map.ACTIVE;
  return <span style={S.pill(color, bg)}>{status}</span>;
};

export default StatusPill;
